export const defaultProps = {
  item: { type: Object, default: () => {} }
}
